var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`${_vm.getClass}-thermometer-bar `,style:([])},[_c('span',{class:`${_vm.getClass}-thermometer-fill ${_vm.getFillingColor}`,style:(`height: ${
      _vm.getThermometerConfig.actualHeight
    }%; bottom: 0; transform: rotate(${
      _vm.getThermometerConfig.rotate ? 180 : 0
    }deg)`)}),_vm._v(" "),_c('span',{class:`${_vm.getClass}-thermometer-target`,style:(`top: ${_vm.getThermometerConfig.targetHeight}%; color: #5b7185';`)}),_vm._v(" "),_c('span',{class:`${_vm.getClass}-thermometer-zero`,style:(`top: ${_vm.getThermometerConfig.zeroHeight}%;`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }